// Modular reservation config per venue. Reusing this for Rocafort/Valterna
// in the future is just a matter of adding their entry and switching them to the widget.
export const RESERVATION_VENUES = {
  lliria: {
    id: "lliria",
    name: "Ritual Llíria",
    whatsappNumber: "34644936286",      // +34 644 93 62 86
    callNumber: "960 524 647",
    callTel: "+34960524647",
    maxParty: 12,
    closedDays: [2], // 0=Dom, 1=Lun, 2=Mar ... Ritual Llíria cierra los martes
    closedMessage: "Ritual Llíria permanece cerrado los martes. Por favor, elige otro día.",
    // Future: these slots will come from backend availability (schedules, closed days, capacity).
    slots: {
      comida: ["13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00"],
      cena: ["19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30"],
    },
  },
};

export const buildWhatsappMessage = ({ name, phone, party, date, time, email, comments, zone }) => {
  const msg =
`📅 NUEVA SOLICITUD DE RESERVA

👤 Nombre: ${name}
📞 Teléfono: ${phone}
👥 Personas: ${party}
📅 Fecha: ${date}
🕐 Hora: ${time}
📍 Zona preferida: ${zone || "-"}
📧 Email: ${email || "-"}
✍️ Comentarios: ${comments || "-"}

Enviado desde gruporitual.com`;
  return encodeURIComponent(msg);
};
